export const GCS_ORIGIN = "https://storage.googleapis.com/";

// Rewrites a GCS storage URL to route through the /cdn/ proxy, optionally
// asking the edge for a resized variant via ?w=.
// Non-GCS URLs and null/undefined pass through unchanged.
export function toProxiedImageUrl(
  url: string | null | undefined,
  cdnBase: string,
  width?: number,
): string | null {
  if (!url) return null;
  if (!url.startsWith(GCS_ORIGIN)) return url;

  const path = url.slice(GCS_ORIGIN.length);
  const base = cdnBase.endsWith("/") ? cdnBase.slice(0, -1) : cdnBase;

  if (typeof width !== "number" || !Number.isFinite(width) || width <= 0) {
    return `${base}/cdn/${path}`;
  }

  // The source path can already carry a query (signed URLs, ?alt=media).
  // Concatenating "?w=" would fold the width into that value — the worker
  // would never see a `w` param and would silently fall back to the cap.
  const queryStart = path.indexOf("?");
  const objectPath = queryStart === -1 ? path : path.slice(0, queryStart);
  const params = new URLSearchParams(
    queryStart === -1 ? "" : path.slice(queryStart + 1),
  );
  params.set("w", String(Math.round(width)));
  return `${base}/cdn/${objectPath}?${params.toString()}`;
}
